<template>
  <div class="sign-container">
    <div class="sign">
      <div>
        <a-button type="primary" class="home" @click="showCode">签名提交</a-button>
        <div v-if="showLogSign" class="use-sign" @click="handleLogSign">使用历史签名</div>
      </div>
      <div style="width: 200px;height: 100px;" v-if="type != 'collect'">
        <img class="signImg" v-if="value" :src="value" alt="" />
      </div>
    </div>

    <a-modal v-model="open" :maskClosable="false" title="签字二维码" @cancel="handleCancel">
      <a-button slot="footer" @click="handleCancel">我已完成</a-button>
      <div style="display: flex;align-items: center;">
        <div style="width: 228px;height: 228px;position: relative;">
          <canvas ref="qrcode"></canvas>
          <div v-if="isTimeout" class="timeout-mask">
            <a-icon type="sync" class="sync-icon" @click="refreshCode" />
          </div>
        </div>
        <div style="margin-left: 16px;">
          <p :style="isTimeout ? 'font-weight: bold;font-size: 18px;' : ''">
            {{ isTimeout ? '二维码已失效' : '打开手机扫描二维码' }}
          </p>
          <p>{{ isTimeout ? '请重新点击按钮生成' : '按说明完成签名确认' }}</p>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import QRCode from 'qrcode';
import { mapState } from 'vuex';
import { throttle } from '@/utils/util';
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
    docId: String,
    showLogSign: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.$bus.$on('getSign', this.getSign);
  },
  computed: {
    ...mapState(['userInfo']),
    codeUrl() {
      const baseUrl = process.env.signUrl;
      return `${baseUrl}#/pages/sign/sign?name=${encodeURIComponent(this.userInfo.name)}&stuId=${this.userInfo.id}&field=${this.item.label}&docId=${
        this.docId
      }&eduCode=${this.userInfo.eduCode}&timestamp=${this.timestamp}`;
    },
  },
  data() {
    return {
      open: false,
      timestamp: null,
      isTimeout: false,
      timer: null,
    };
  },
  methods: {
    showCode() {
      if (this.type == 'collect') {
        this.$emit('open', 1);
      } else {
        this.openSign();
      }
    },
    openSign() {
      this.open = true;
      this.setTime();
    },
    handleLogSign() {
      this.axios.get(`/biz/home/sign/his?docId=${this.docId}`).then(res => {
        if (res.result) {
          this.$emit('change', res.result);
          this.$emit('ok', res.result);
        }
      });
    },
    refreshCode() {
      throttle(this.setTime(), 200);
    },
    async setTime() {
      const res = await this.axios.get('/common/qry/timeStamp');
      this.timestamp = +res.result;
      this.isTimeout = false;
      this.$nextTick(() => {
        QRCode.toCanvas(this.$refs.qrcode, this.codeUrl, error => {
          if (error) console.error(error);
          console.log('success!');
          this.timer = setTimeout(() => {
            this.isTimeout = true;
            this.timer && clearTimeout(this.timer);
          }, 1000 * 60 * 5);
        });
      });
    },
    getSign(data) {
      if (this.type == 'collect') {
        if (data.docId == this.docId) {
          this.$emit('ok', data.fileUrl);
          this.open = false;
        }
      } else {
        if (data.field === this.item.label) {
          this.$emit('change', data.fileUrl);
          this.$emit('ok', data.fileUrl);
          this.open = false;
        }
      }
    },
    handleCancel() {
      this.open = false;
      this.timer && clearTimeout(this.timer);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
.sign{
  display: flex;
  .use-sign {
    color: $bgColor;
    cursor: pointer;
  }
  .home{
    background: $bgColor;
    color: #fff;
    border: none;
  }
  .signImg{
    margin-left: 24px;
    transform: rotateZ(-90deg);
    transform-origin: 50% 50px;
    width: 100px;
    height: 200px;
  }
}

.timeout-mask {
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, .9);
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sync-icon {
  font-size: 36px;
  cursor: pointer;
  color: #2caf7a;
  background-color: #fff;
  padding: 8px;
  border-radius: 50%;
  border: 2px solid #2caf7a;
}
</style>



// WEBPACK FOOTER //
// src/common/components/sign.vue